<template>
  <div id="number">
    <!--    <div class="bg-color-black">-->
    <div class="d-flex pt-2 pl-2">
        <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">平台交易总额</span>
        </span>
    </div>
    <div class="up">
      <div class="tit">
        <h2><i class="iconfont icon-jishu1 "></i>成果转化</h2>
        <h2><i class="iconfont icon-tianshijijin "></i>易智商城</h2></div>

      <div class="item">
        <div class="amount float-l">

          <p style="font-size: 18px;color:#5cd9e8;text-align: center">
            <i class="icon-dot" style="color:#ed3f35 "></i>交易笔数<span>{{ Num1 }}</span>笔
          </p>

          <p style="font-size: 18px;color:#5cd9e8;text-align: center">
            <i class="icon-dot" style="color:#ed3f35 "></i>交易金额<span>{{ toThousands(Amount1) }}</span>元
          </p>
        </div>
      </div>
      <div class="item">

        <div class="amount float-l">

          <p style="font-size: 18px;color:#5cd9e8;text-align: center">
            <i class="icon-dot" style="color:#ed3f35 "></i>交易笔数<span>{{ Num2 }}</span>笔
          </p>

          <p style="font-size: 18px;color:#5cd9e8;text-align: center">
            <i class="icon-dot" style="color:#ed3f35 "></i>交易金额<span>{{ toThousands(Amount2) }}</span>元
          </p></div>
      </div>
    </div>
  </div>
  <!--  </div>-->
</template>

<script>
// import CenterChart from "@/components/echart/center/centerChartRate";
import sciApi from '@/api/index.js'

export default {
  data() {
    return {
      sum: 0,
      Num1: 0,
      Amount1: 0,
      Num2: 0,
      Amount2: 0,
      allAmount: [],
      allNum: []
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    toThousands(num) {
      return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    },
    async init() {
      // await sciApi.selectTechnology({})
      await sciApi.selectTechnology({level1: "384354211555599101", pageSize: 1000, pageNum: 1}).then((data) => {
        // data 就是接口返回值
        this.allAmount = data.list || []
        this.sum = 0
        this.allAmount.forEach((item) => {
          if(item.level2Display=='技术交易'){
            this.sum += parseInt(item.mapNum || 0)
            this.Amount1 = this.sum
          }
          if(item.level2Display=='易智商城'){
            this.sum += parseInt(item.mapNum || 0)
            this.Amount2 = this.sum
          }
        })



      })
      await sciApi.selectTechnology({level1: "384354211555599100", pageSize: 1000, pageNum: 1}).then((data) => {
        // data 就是接口返回值
        this.allNum = data.list || []
        this.sum = 0
        this.allNum.forEach((item) => {
          if(item.level2Display=='技术交易'){
            this.sum += parseInt(item.mapNum || 0)
            this.Num1 = this.sum
          }
          if(item.level2Display=='易智商城'){
            this.sum += parseInt(item.mapNum || 0)
            this.Num2 = this.sum
          }
        })
      })
    }
  }
};
</script>

<style lang="scss" scoped>
#number {
  padding: 0.2rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .up {
    width: 100%;
    height: 90%;
    display: flex;
    flex-wrap: wrap;
    //padding: 1rem 0.5rem;
    //justify-content: space-around;
    .tit {
      width: 100%;
      margin-top: 0.3rem
    }

    .tit h2 {
      float: left;
      width: 50%;
      height: auto;
      margin-top: 0.1rem;
      text-align: center;
      color: #5cd9e8;
      font-size: 0.3rem

    }

    .item {
      float: left;
      width: 50%;
      height: auto;
      text-align: center;
    }

    .item .amount {
      font-size: 18px;
      color: #5cd9e8;
      text-align: center;
      width: 100%;
    }

    .amount span {
      color: #ffffff;
      font-size: 0.5rem;
      line-height: 42px;
      margin-bottom: 10px;
      margin-right: 10px;
      margin-left: 10px;
      display: inline-block;
    }

    .tit .iconfont {
      font-size: 0.5rem !important;
      color: #5cd9e8;
      margin-right: 0.1rem;
      vertical-align: middle;
    }
  }
}
</style>